import { useEffect, useState } from "react";
// import { transactions } from "../../Utils/data";
import { Abonnement } from "../../components/Abonnement/Abonnement";
import { Paiement } from "../../components/Paiement/Paiement";
import { Tabs } from "../../components/Widget/Tab";
import { checkTagValidity } from "../../Utils/Utils";

const Paiements = () => {
  const [active, setActive] = useState(null);

  const listeTabsData = [
    {
      index: 0,
      value: "En attente de paiement",
      tag: "LISTE_EN_ATTENTE_PAIEMENT",
    },
    {
      index: 1,
      value: "Intention payée",
      tag: "LISTE_PAYER",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));
  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);

  return (
    <div className="w-full ">
      <div className="lg:flex gap-x-2">
        <h1 className="font-mtn text-3xl font-extrabold text-black">
          Collecte de paiement
        </h1>
      </div>

      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}

      {active && active.tag === "LISTE_EN_ATTENTE_PAIEMENT" ? (
        <Abonnement
          status={"EN_ATTENTE_DE_PAIEMENT"}
          perm={"POURSUIVRE_PAIEMENT"}
          step={2}
        />
      ) : active && active.tag === "LISTE_PAYER" ? (
        <Paiement />
      ) : null}
    </div>
  );
};

export default Paiements;
